import React from "react";
import { useSelector } from "react-redux";
import GuestNavbar from "./GuestNavbar";
import AuthenticatedNavbar from "./AuthenticatedNavbar";

/**
 * Top nav for the whole consumer site: marketing pages (`/`, `/about`, category hubs, …)
 * and `/profile` all use this shell. Guests see GuestNavbar links; signed-in users with a
 * token see AuthenticatedNavbar. Auth-only screens (`/signin`, `/signup`, …) hide the nav in App.
 */
const Navbar = () => {
  const { token } = useSelector((state) => state.infoboxx_consumer);
  const showAuthenticatedNavbar = Boolean(token);
  return showAuthenticatedNavbar ? (
    <AuthenticatedNavbar />
  ) : (
    <GuestNavbar hideFeedback />
  );
};

export default Navbar;
